import { useEffect, useState } from "react"
import { Tabs, TabPanel } from "react-tabs"
import { useMediaQuery } from "react-responsive"
import { AppHeader } from "./components/output/AppHeader"
import { renderAppTabList } from "./components/AppTabList"
import { DashboardPage } from "./components/dashboard/DashboardPage"
import { WasmRunner } from "@coherentglobal/wasm-runner"
import { DashboardTab } from "./components/dashboard/DashboardTab"
import { PerformanceForm } from "./components/PerformanceForm"
import { AboutTab } from "./components/AboutTab"
import { AppFooter } from "./components/AppFooter"
import { ToastContainer } from "react-toastify"

function App() {
  const [runner, setRunner] = useState<null | WasmRunner>(null)
  const [request, setRequest] = useState<any>(null)
  const [response, setResponse] = useState<any>({})
  const [tabIndex, setTabIndex] = useState<number>(0)
  const isMobile = useMediaQuery({ query: "(max-width: 1024px)" })

  const initWasmRunner = async () => {
    const id = "eb3b7f9a-c39a-4178-a85d-176b6d7dfe09"
    const url = "/Spark_401k_Pricing_Model.zip"
    const wasmRunner = new WasmRunner()
    await wasmRunner.append({ id, url })
    await wasmRunner.initialize()
    setRunner(wasmRunner)
  }

  useEffect(() => {
    const init = async () => {
      await initWasmRunner()
    }
    init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="h-full bg-form-medium">
      <Tabs className="react-tabs h-full" selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        {isMobile ? (
          <>
            <AppHeader />
            <div className={`overflow-y-hidden mt-16 ${tabIndex === 0 ? "mb-44" : "mb-20"}`}>
              <TabPanel className="space-y-6 bg-form-medium">
                <DashboardTab
                  request={request}
                  response={response.response_data ? response : null}
                  setResponse={setResponse}
                  setRequest={setRequest}
                  setTabIndex={setTabIndex}
                  initWasmRunner={initWasmRunner}
                  runner={runner!}
                />
              </TabPanel>

              <TabPanel>
                <PerformanceForm runner={runner!} />
              </TabPanel>

              <TabPanel>
                <AboutTab />
              </TabPanel>
            </div>

            {renderAppTabList(isMobile)}
          </>
        ) : (
          <>
            <AppHeader>{renderAppTabList(isMobile)}</AppHeader>
            <div className="h-full overflow-y-hidden mt-16 mb-10">
              <TabPanel
                selectedClassName="w-full bg-form-medium !h-[calc(100vh-2.25rem-4rem)] !flex justify-center items-flex-start overflow-y-hidden"
                className=""
              >
                <div className="w-full overflow-y-auto relative">
                  <DashboardPage
                    request={request}
                    response={response.response_data ? response : null}
                    setResponse={setResponse}
                    setRequest={setRequest}
                    initWasmRunner={initWasmRunner}
                    runner={runner!}
                  />
                </div>
              </TabPanel>

              <TabPanel selectedClassName="w-full !h-[calc(100vh-2.25rem-4rem)] overflow-y-auto" className="">
                <PerformanceForm runner={runner!} />
              </TabPanel>

              <TabPanel selectedClassName="w-full !h-[calc(100vh-2.25rem-4rem)] overflow-y-auto" className="">
                <AboutTab />
              </TabPanel>
            </div>
            <AppFooter />
          </>
        )}
      </Tabs>

      <ToastContainer limit={1} />
    </div>
  )
}

export default App

